export const OrganizationDataErrorType = {
    agbStartDateMismatch: 'agbStartDateMismatch',
    duplicateAddress: 'duplicateAddress',
    duplicateAgbCode: 'duplicateAgbCode',
    duplicateKvkNumber: 'duplicateKvkNumber',
    duplicateNameStatutory: 'duplicateNameStatutory',
    expiredAgb: 'expiredAgb',
    invalidAgb: 'invalidAgb',
    missingAddress: 'missingAddress',
    missingAgb: 'missingAgb',
    missingKvkNumber: 'missingKvkNumber',
    missingNameStatutory: 'missingNameStatutory',
    vektisAddressMismatch: 'vektisAddressMismatch',
    vektisKvkNumberMismatch: 'vektisKvkNumberMismatch',
    vektisNameStatutoryMismatch: 'vektisNameStatutoryMismatch',
} as const;

export type OrganizationDataErrorType = (typeof OrganizationDataErrorType)[keyof typeof OrganizationDataErrorType];

export type DuplicateOrganizationDataErrorType =
    | typeof OrganizationDataErrorType.duplicateAddress
    | typeof OrganizationDataErrorType.duplicateAgbCode
    | typeof OrganizationDataErrorType.duplicateKvkNumber
    | typeof OrganizationDataErrorType.duplicateNameStatutory;
